<template>
	<PopUp
		title="Stellenprofil nicht mehr veröffentlichen"
		size="lg"
		ok-text="Veröffentlichung aufheben"
		:ok-disabled="unpublishing"
		:ok-loading="unpublishing"
		:hide-cancel="unpublishing"
		@ok="unpublish"
		@hidden="$emit('hidden')"
	>
		<div>Soll das Stellenprofil wirklich nicht mehr veröffentlicht sein?</div>
		<div class="mt-2">Es kann dadurch von Kandidaten nicht mehr gefunden werden, da dein Stellenprofil in keinen Listen mehr aufscheint.</div>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp"
import Change, {ACTION_UNPUBLISH} from "@/api/job-profile/status/Change";
import flatten from "@/helper/error/Errors";
import * as Toast from "@/helper/layout/Toast"

export default {

	components: {
		PopUp,
	},

	props: {
		jobProfile: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			unpublishing: false,
		};
	},

	methods: {
		async unpublish ()
		{
			this.unpublishing = true;

			try
			{
				await new Change()
					.setJobProfileId(this.jobProfile.id)
					.setAction(ACTION_UNPUBLISH)
					.call();

				this.$emit('unpublish');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.unpublishing = false;
		}
	}
}
</script>
